<template>
    <div id="mPlanos" class="modal fade" data-backdrop="true" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content rounded">
                <!-- Modal content-->
                <div class="modal-body p-0 text-justify" style="height:calc(100vh - 58px);">
                    <div class="row h-100 m-0">
                        <div class="d-none d-md-flex col-md-4 p-0">
                            <img class="h-100" src="@/assets/login/formulario.png" alt="Formulario"
                                style="object-fit:cover;object-position:center;">
                        </div>
                        <div class="col bg-white">
                            <div class="row px-3 justify-content-between align-items-start">
                                <div class="col text-center">
                                    <h3 class="text-center my-3">Plano: Personalizado </h3>
                                </div>
                                <button id="btnFechar" type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                                    <span aria-hidden="true" style="font-size: 35px;">×</span>
                                </button>
                            </div>
                            <div class="row align-items-center">
                                <div class="col-10 text-left px-0 mx-auto">
                                    <div class="row mb-3 align-items-center"
                                        :class="{'is-invalid': errors.has('Usuarios')}">
                                        <div class="col-12 col-lg-8 pr-0" style="line-height:1">
                                            <p class="m-0">Quantidade de Usuários/Acessos</p>
                                            <small style="font-size:x-small;">
                                                <i class="fa fa-arrow-right text-gray"></i>
                                                Os signatários são ilimitado
                                            </small>
                                        </div>
                                        <div class="col-12 col-lg-4">
                                            <input v-validate="{required: true, min:1}" v-model="request.users"
                                                id="users" name="Usuarios" type="number" min="1" step="1"
                                                placeholder="1" />
                                        </div>
                                    </div>
                                    <div class="row mb-3 align-items-center"
                                        :class="{'is-invalid': errors.has('Arquivos')}">
                                        <div class="col-12 col-lg-8 pr-0">
                                            <p class="m-0" style="line-height:1">Quantidade de Arquivos/Uploads</p>
                                        </div>
                                        <div class="col-12 col-lg-4">
                                            <input v-validate="{required: true, min:1}" v-model="request.files"
                                                id="files" name="Arquivos" type="number" min="1" step="1"
                                                placeholder="1" />
                                        </div>
                                    </div>
                                    <div class="row mb-3 align-items-center"
                                        :class="{'is-invalid': errors.has('Tamanho-MBs')}">
                                        <div class="col-12 col-lg-8 pr-0">
                                            <p class="m-0" style="line-height:1">Tamanho em MBs dos arquivos</p>
                                        </div>
                                        <div class="col-12 col-lg-4">
                                            <input v-validate="{required: true}" v-model="request.size" id="filesSize"
                                                name="Tamanho-MBs" type="number" min="1" placeholder="50" />
                                        </div>
                                    </div>
                                    <div class="mb-3 w-100" :class="{'is-invalid': errors.has('Empresa')}">
                                        <input v-validate="{required: true}" v-model="request.company" name="Empresa"
                                            type="text" placeholder="Empresa" />
                                    </div>
                                    <div class="mb-3 w-100" :class="{'is-invalid': errors.has('Contato')}">
                                        <input v-validate="{required: true}" v-model="request.agent" name="Contato"
                                            type="text" placeholder="Contato" />
                                    </div>
                                    <div class="mb-3 w-100" :class="{'is-invalid': errors.has('Telefone-Fixo')}">
                                        <input
                                            v-mask="[(request.phone && (request.phone.replace(/\D/g,'')).length>=11)? '#### ### ####' : '(##)####-####']"
                                            name="Telefone-Fixo" v-model="request.phone" type="text"
                                            v-validate="{required: (!request.mobile)}" placeholder="Telefone Fixo" />
                                    </div>
                                    <div class="mb-3 w-100" :class="{'is-invalid': errors.has('Telefone-Celular')}">
                                        <input v-mask="['(##)# ####-####']" name="Telefone-Celular"
                                            v-validate="{required: (!request.phone)}" v-model="request.mobile"
                                            type="text" placeholder="Telefone Celular" />
                                    </div>
                                    <div class="mb-3 w-100" :class="{'is-invalid': errors.has('Email')}">
                                        <input v-validate="{required: true}" v-model="request.email"
                                            name="Email" type="email" placeholder="E-mail" />
                                    </div>
                                    <div class="mb-3 w-100">
                                        <textarea v-model="request.message" name="Mensagem"
                                            style="min-height:100px;max-height:100px;"
                                            placeholder="Mensagem... (Opcional)" rows="3" class="w-100"> </textarea>
                                    </div>
                                    <div class="mb-3 form-check">
                                        <input v-model="request.auth" type="checkbox" id="checkTermos"
                                            class="form-check-input" name="Check" />
                                        <label for="checkTermos" class="form-check-label">Concordo com o
                                            <a data-toggle="modal" data-target="#ChangeTermos"><u class="text-primary"
                                                    style="cursor:pointer;">Termo</u></a> e com o recebimento de emails
                                            da AR MBD, proprietária da plataforma DocXDigital.</label>
                                    </div>
                                    <div class="row my-3 mx-0 justify-content-between">
                                        <button :disabled="loading" class="btn btn-outline-secondary px-3" id="btnClose"
                                            data-dismiss="modal" aria-label="Close">
                                            <i class="fa fa-times"></i> Cancelar
                                        </button>
                                        <button @click="mountMail()" :disabled="loading" id="btnConfirm"
                                            class="btn btn-success px-3">
                                            <i class="fa fa-send"></i> Enviar
                                            <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
    export default {
        data() {
            return {
                loading: false,
                request: {
                    type: 'Plano Personalizado',
                    users: null,
                    files: null,
                    size: null,
                    company: null,
                    agent: null,
                    phone: null,
                    mobile: null,
                    email: null,
                    message: null,
                    auth: true,
                    grecaptcha: null,
                }
            }
        },
        mounted() {
            $('#mPlanos').on('hide.bs.modal', () => {
                this.$validator.reset();
                this.clear();
            });
        },
        methods: {
            async mountMail() {
                this.loading = true;
                this.request.grecaptcha = await this.$recaptcha("contato").then(token => {
                    return token;
                });
                this.$validator.validateAll().then(valid => {
                    if (valid) this.sendEmail();
                    else toastr({
                        title: 'Preencha os campos!!',
                        icon: 'error', // error, warning, info, success
                        position: 'top-right',
                        showConfirmButton: false,
                        showCancelButton: false,
                        html: null,
                        timer: 5000
                    })
                }).finally(() => {
                    this.loading = false;
                })
            },
            sendEmail() {
                this.loading = true;
                axios.post('/api/email-contato', this.request).then(response => {
                    toastr({
                        title: response.data.message,
                        icon: response.data.status,
                        position: 'top-right',
                        showConfirmButton: false,
                        showCancelButton: false,
                        html: null,
                        timer: 5000
                    });
                    $('#mPlanos').modal('hide');
                }).catch(error => {
                    return error.response.data;
                }).finally(() => {
                    this.loading = false;
                })
            },
            clear() {
                this.request = {
                    type: 'Plano Personalizado',
                    users: null,
                    files: null,
                    size: null,
                    company: null,
                    agent: null,
                    phone: null,
                    mobile: null,
                    email: null,
                    message: null,
                    auth: true,
                    grecaptcha: null,
                }
            }
        }
    }
</script>

<style scoped src="@/assets/sass/bootstrap4.css"></style>
<style scoped>
    .modal-body {
        max-height: 100%;
        font-family: 'Montserrat', sans-serif;
    }

    input:not([type='checkbox']) {
        width: 100%;
        border: 0;
        background-color: transparent;
        border-bottom: 1px solid dimgray;
    }

    input:focus,
    textarea:focus {
        outline-width: 0;
    }

    .is-invalid,
    .is-invalid input::placeholder {
        color: #dc3545;
    }

    .is-invalid input {
        border-bottom: 1px solid #dc3545;
    }

    .help-block {
        font-size: 12px;
        margin: 0;
    }

    .btn {
        font-size: 14px;
    }
</style>